import { z } from 'zod';
// Training deliberately repeats the public Timesheets host literals instead of
// importing the optional Timesheets package. Release composition tests bind
// these values to the installed host when it exists.
export const trainingTimesheetSummaryHostCapability = 'timesheets.activity-review-host.v1';
export const trainingTimesheetSummaryHostFallbackCapability = 'training.degraded.timesheets-activity-host-unavailable.v1';
export const trainingTimesheetSummaryHostSlot = 'timesheets.activity-review.summary';
export const trainingTimesheetSummaryHostResourceType = 'timesheets.membership-activity-window';
export const trainingTimesheetSummaryHostContextSchema = z.strictObject({
    resourceType: z.literal(trainingTimesheetSummaryHostResourceType),
    resourceId: z.string().uuid(),
    parameters: z.strictObject({
        resourceLabel: z.string().trim().min(1).max(200),
        fromInclusive: z.string().datetime({ offset: true }),
        toExclusive: z.string().datetime({ offset: true }),
    }),
}).superRefine((value, context) => {
    if (Date.parse(value.parameters.toExclusive) <= Date.parse(value.parameters.fromInclusive)) {
        context.addIssue({
            code: 'custom',
            path: ['parameters', 'toExclusive'],
            message: 'The Training summary host end must follow its start.',
        });
    }
});
//# sourceMappingURL=training-timesheet-summary-host.contract.js.map